import React from 'react'
import "../styles/subpages.css"

const Legal = () => {
  return (
    <>

    </>
  )
}

export default Legal